import { render, staticRenderFns } from "./OTParcelEmployee.vue?vue&type=template&id=173e0146&scoped=true&"
import script from "./OTParcelEmployee.vue?vue&type=script&lang=js&"
export * from "./OTParcelEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e0146",
  null
  
)

export default component.exports